export default __webpack_public_path__ + "static/media/logo_etm_negro.114d9a7b.png";